import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900 rounded-lg shadow-lg p-3 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_2 = { class: "flex items-center justify-between mb-3" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "text-xs font-semibold text-gray-900 dark:text-white" }
const _hoisted_5 = { class: "flex items-center space-x-1" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex items-center justify-center space-x-2 mb-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "w-12 h-16 bg-gray-100 dark:bg-gray-700 rounded-md overflow-hidden" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 0,
  class: "absolute inset-0 bg-gradient-to-t from-blue-500/20 to-transparent rounded-md"
}
const _hoisted_13 = { class: "absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10" }
const _hoisted_14 = { class: "flex items-center justify-center space-x-2 mb-2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 animate-pulse"
}
const _hoisted_17 = { class: "absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10" }

interface Variation {
  id: string
  imageUrl: string
  thumbnailUrl?: string
  dimensions: {
    width: number
    height: number
  }
  validationScore?: number
  isPrimary: boolean
}

interface Props {
  currentIndex: number
  totalVariations: number
  variations: Variation[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VariationNavigator',
  props: {
    currentIndex: {},
    totalVariations: {},
    variations: {}
  },
  emits: ["previous", "next", "select-variation"],
  setup(__props: any) {





// Handle image loading errors
const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement
  // Fallback to a placeholder
  img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA0OCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjY0IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNiAxNkgyNFYyNEgxNlYxNloiIHN0cm9rZT0iIzlDQTNBRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIwIDIwTDIyIDIyTDI0IDIwTDI2IDIyVjI4SDE4VjIyTDIwIDIwWiIgc3Ryb2tlPSIjOUNBM0FGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-1.5 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg animate-pulse" }, [
          _createElementVNode("svg", {
            class: "w-4 h-4 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            })
          ])
        ], -1)),
        _createElementVNode("h4", _hoisted_4, " Variation " + _toDisplayString(_ctx.currentIndex + 1) + "/" + _toDisplayString(_ctx.totalVariations), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previous'))),
          disabled: _ctx.currentIndex === 0,
          class: _normalizeClass(["p-1.5 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-blue-100 dark:hover:bg-blue-900/30 hover:text-blue-600 dark:hover:text-blue-400 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 hover:scale-110 active:scale-95 group", { 'animate-pulse': _ctx.currentIndex === 0 }])
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            class: "w-3 h-3 transform group-hover:-translate-x-0.5 transition-transform",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 19l-7-7 7-7"
            })
          ], -1)
        ]), 10, _hoisted_6),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next'))),
          disabled: _ctx.currentIndex === _ctx.totalVariations - 1,
          class: _normalizeClass(["p-1.5 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-blue-100 dark:hover:bg-blue-900/30 hover:text-blue-600 dark:hover:text-blue-400 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 hover:scale-110 active:scale-95 group", { 'animate-pulse': _ctx.currentIndex === _ctx.totalVariations - 1 }])
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "w-3 h-3 transform group-hover:translate-x-0.5 transition-transform",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })
          ], -1)
        ]), 10, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variations, (variation, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (_ctx.$emit('select-variation', index)),
          class: _normalizeClass([
          'flex-shrink-0 rounded-lg transition-all duration-300 cursor-pointer relative overflow-hidden group border-2',
          _ctx.currentIndex === index 
            ? 'border-blue-500 shadow-lg scale-105' 
            : 'border-gray-200 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-500 hover:scale-110'
        ])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: variation.thumbnailUrl || variation.imageUrl,
              alt: `Variation ${index + 1}`,
              class: "w-full h-full object-cover transition-transform duration-300 group-hover:scale-110",
              onError: handleImageError
            }, null, 40, _hoisted_11)
          ]),
          (_ctx.currentIndex === index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "absolute top-1 right-1 w-2 h-2 bg-blue-500 rounded-full animate-pulse" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200 rounded-md flex items-center justify-center\" data-v-1c72a1b9><div class=\"opacity-0 group-hover:opacity-100 transition-opacity duration-200\" data-v-1c72a1b9><svg class=\"w-4 h-4 text-white drop-shadow-lg\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-1c72a1b9><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\" data-v-1c72a1b9></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z\" data-v-1c72a1b9></path></svg></div></div>", 1)),
          _createElementVNode("div", _hoisted_13, " Variation " + _toDisplayString(index + 1), 1)
        ], 10, _hoisted_9))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalVariations, (_, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (_ctx.$emit('select-variation', index)),
          class: _normalizeClass([
          'rounded-full transition-all duration-300 cursor-pointer relative overflow-hidden group',
          _ctx.currentIndex === index 
            ? 'w-6 h-2 bg-gradient-to-r from-blue-500 to-purple-500 shadow-lg' 
            : 'w-2 h-2 bg-gray-300 dark:bg-gray-600 hover:bg-blue-400 dark:hover:bg-blue-500 hover:scale-125'
        ])
        }, [
          (_ctx.currentIndex === index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16))
            : _createCommentVNode("", true),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-0 bg-white opacity-0 group-hover:opacity-30 group-active:opacity-50 transition-opacity duration-200 rounded-full" }, null, -1)),
          _createElementVNode("div", _hoisted_17, " Variation " + _toDisplayString(index + 1), 1)
        ], 10, _hoisted_15))
      }), 128))
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("div", { class: "inline-flex items-center space-x-1 text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 px-2 py-1 rounded-full" }, [
        _createElementVNode("svg", {
          class: "w-3 h-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 10V3L4 14h7v7l9-11h-7z"
          })
        ]),
        _createElementVNode("span", null, "Use ← → keys or swipe")
      ])
    ], -1))
  ]))
}
}

})